// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-billboard-css {
  font-family: Roboto;
  color: var(--Colors-Primary-500, #d2042d);
}

.add-billboard-design {
  font-family: Roboto;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 600;
}
.width-style-100{
  width: 100% !important;
}
.add-billboard-images {
  font-family: Roboto;
  text-align: center;
  border-radius: 0.625rem;
  border: 2px dashed #000;
  width: 100%;
  height: 33.5rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
/* Multi slot booking calendar stylings */
.new-calendar-slots-row {
  background: #f5f5f5;
  border-radius: 10px;
  display: flex;
  flex-direction: column !important;
  padding: 15px;
  width: 100% !important;
}
.multiple-slot-description {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #626262;
}
.multiple-slot-add-button {
  border-radius: 5px;
  padding: 12px !important;
  background: var(--Colors-Text-400, #3b3f3d) !important;
  cursor: pointer;
  height: max-content;
  border-color: #3b3f3d !important;
}
.multiple-slot-combo-col {
  width: 100% !important;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  gap: 0.8rem !important;
  flex-wrap: wrap;
}
.range-picker-wrapper {
  position: relative;
}

.always-clear-icon {
  position: absolute;
  right: 34px;
  top: 38%;
  transform: translateY(-50%);
  opacity: 0;
  cursor: pointer;
  z-index: 10;
  transition: opacity 0.2s ease;
  font-size: 12px;
  position: absolute;
  color: #ffffff;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #bfbfbf;
  display: flex;
  align-items: center;
  justify-content: center;
}
.availability-ranges-text {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}
.range-picker-wrapper:hover .always-clear-icon {
  opacity: 1;
}

/* Optional */
.range-picker-wrapper .ant-picker-suffix {
  transition: opacity 0.2s ease;
}

.range-picker-wrapper:hover .ant-picker-suffix {
  opacity: 0;
}
.seller-multiple-slot-form-item {
  width: 30% !important;
}
.multiple-slot-add-button-text {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #ffffff;
  align-items: center;
}
.billboard-image-main-div {
  height: 33.5rem !important;
  width: 100% !important;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  border-radius: 0.625rem;
}
.billboard-select-feild {
  font-family: Roboto;
  width: 100%;
  height: 3.125rem;
  padding: 0.2rem 0.5rem;
  align-items: center;
  border-radius: 0.3125rem;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);
  background: #fcfcfc;
}
.ant-input-affix-wrapper:not(.ant-input-disabled):hover {
  z-index: 0;
}
.ant-input-affix-wrapper:focus {
  z-index: 0;
}
.billboard-select-feild .ant-select-item-option-state {
  display: none !important;
}

.billboard-select-dropdown
  .ant-select-item-option-selected
  .ant-select-item-option-state {
  color: #fff !important;
}

.billboard-select-feild .ant-select-selection-item {
  font-size: 1rem !important;
  font-style: normal;
  font-weight: 500;
  color: var(--Colors-Text-500, #0a0f0d) !important;
}

@media (max-width: 1024px) {
  .billboard-select-feild .ant-select-selection-item {
    font-size: 1rem !important;
    font-style: normal;
    font-weight: 500 !important;
    color: var(--Colors-Text-500, #0a0f0d) !important;
  }
}

.billboard-select-feild .ant-select-selector {
  background: #fcfcfc !important;
}

.billboard-select-feild .ant-select-selector:hover {
  border-color: none;
}

.billboard-select-feild .ant-select-selection-wrap {
  .ant-select-selection-placeholder {
  color: #757575 !important;
  font-size: 14px !important;
  font-style: normal;
  font-weight: 400;
  font-family: 'Roboto';
  }
}

.billboard-input-feild {
  height: 3.125rem;
  padding: 0.625rem 1.25rem 0rem 1.25rem !important;
  align-items: center;
  margin-top: 0;
  font-size: 14px;
  border-radius: 0.3125rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  background: #fcfcfc !important;
  border-color: #fcfcfc;
  font-family: "Roboto";
  box-shadow: none;
}
.billboard-input-feildterm {
  height: 3.125rem;
  padding: 0.625rem 1.25rem 0rem 1.25rem !important;
  align-items: center;
  margin-top: 0;
  font-size: 1rem;
  border-radius: 0.3125rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  /* background: #fcfcfc !important; */
  border-color: #fcfcfc;
  font-family: "Roboto";
  box-shadow: none;
}
.billboard-input-feildterm:hover{
  background-color: none !important;
}
.payment-term-amount {
  border-radius: 0.5rem !important;
  border-bottom: #f0f0f0 !important;
  background-color: #f0f0f0 !important;
}

.billboard-text-area {
  padding: 1.1rem 1.25rem !important;
  line-height: 2rem;
}

.billboard-text-area.ant-input-outlined {
  border-color: #fff !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
}

.billboard-text-area.ant-input-out-of-range {
  color: var(--Colors-Text-400, #3b3f3d) !important;
}

.billboard-input-feild.ant-input-outlined:focus {
  border-color: #fff !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  box-shadow: none !important;
}

.billboard-input-feild input::placeholder {
  color: #999;
  font-weight: 400;
}

.billboard-input-feild:not(:placeholder-shown) {
  padding-bottom: 0 !important;
}

.billboard-input-feild label {
  padding-left: 10px !important;
}

.billboard-input-feild .floating-label.focused {
  font-size: var(--label-focused-font-size, 12px);
  color: var(--label-focused-color, #f10c0c);
  top: 23px !important;
  transform: none !important;
  z-index: 1;
  padding-left: 10px !important;
}

.billboard-input-feild.ant-form-item-control-input-content {
  border-radius: 0.3125rem !important;
  background: #fcfcfc !important;
}

.billboard-input-feild input {
  padding-left: 0;
  font-weight: var(--input-font-weight, 500);
}

.billboard-input-feild::placeholder {
  font-weight: var(--placeholder-font-weight, 400);
  color: #757575 !important;
  padding-left: -1.25rem !important;
}

.billboard-input-feild.ant-input-status-error {
  border-style: none !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
}

.billboard-form {
  display: flex;
}

.billboard-form-row {
  margin-top: 0.5rem;
  width: 100%;
  gap: 0.8rem;
  flex-flow: nowrap;
}

.billboard-form-column {
  width: 32%;
}

.billboard-form-child-column {
  width: 50%;
}

.icon-input-feild input {
  background: #fcfcfc !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
}

.payment-term input {
  border-radius: 0.5rem !important;
  background: #f0f0f0 !important;
}

/* Shared Input Styles */
.icon-input-feild input,
.payment-term input {
  font-family: Roboto;
  font-weight: 500;
  font-size: 1rem;
  height: 3.125rem;
  align-items: center;
  margin-top: 0;
  border: none;
}

.icon-input-feild input:not(:placeholder-shown),
.icon-input-feild input:not([value=""]),
.payment-term input:not(:placeholder-shown),
.payment-term input:not([value=""]) {
  border-radius: 0.5rem;
  padding-bottom: 0 !important;
}

.icon-input-feild input::placeholder,
.payment-term input::placeholder {
  font-weight: 400;
  color: #757575 !important;
  padding-left: 1.25rem;
}

.ant-input-status-error {
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  border: none !important;
}

/* Error input handling */

.payment-term .ant-input-status-error {
  border: none !important;
}

.icon-input-feild .ant-input-group-addon {
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
}

/* Addon Styles */
.icon-input-feild .ant-input-group-addon,
.payment-term .ant-input-group-addon {
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  border: none;
  background: #f0f0f0;
  color: var(--Colors-Text-200, #8e9190) !important;
}

/* Overwrite for payment-term addon */
.payment-term .ant-input-group-addon {
  background-color: #0a0f0d !important;
  color: #fff !important;
}

.billboard-datepicker {
  width: 100% !important;
  border-left: 0px !important;
  height: 3.125rem !important;
  padding: 0.625rem 1.25rem !important;
  align-items: center !important;
  margin-top: 0 !important;
  font-size: 1rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  background: #fcfcfc !important;
  border-right: 0px !important;
  border-left: 0px !important;
  border-top: 0px !important;
}

.single-calendar {
  width: 30% !important;
}

.single-calendar .ant-picker-range-arrow {
  inset-inline-start: 200px !important;
}

.single-calendar .ant-picker-panel-container {
  display: flex;
}

.single-calendar .ant-picker-panel:first-child .ant-picker-header-next-btn,
.single-calendar
  .ant-picker-panel:first-child
  .ant-picker-header-super-next-btn {
  visibility: visible !important;
}

.single-calendar .ant-picker-panels > div:nth-child(2) {
  display: none !important;
}

.single-calendar .ant-picker-panel:last-child .ant-picker-header-next-btn,
.single-calendar
  .ant-picker-panel:last-child
  .ant-picker-header-super-next-btn {
  visibility: hidden !important;
}

.billboard-datepicker.ant-picker-status-error {
  border-style: none !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
}

.revenue-performance-height {
  font-family: Roboto;
  height: 3.125rem;
}

.billboard-revenue-performance-tab-1 {
  padding: 0.3rem 0.8rem 0.3rem 0.8rem;
  color: #838383;
  cursor: pointer;
}

.billboard-revenue-performance-tab-2 {
  font-weight: 500;
  padding: 0.3rem 0.8rem 0.3rem 0.8rem;
  border-radius: 0.3rem;
  cursor: pointer;
  background: #fff;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.17);
}

.billboard-select-feild-design {
  margin-bottom: 0;
}

.billboard-table {
  border: 1px solid #fcfcfc;
  .ant-table-cell {
    font-family: Roboto;
    padding: 7px 7px !important;
  }
}

.billboard-table .ant-table-thead > tr > th {
  text-align: left !important;
}

.billboard-table .ant-table-thead > tr > th {
  background-color: #0a0f0d !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.billboard-table .ant-pagination {
  display: none;
}

.billboard-table .ant-table-thead > tr > th::before,
.billboard-table .ant-table-thead > tr > td::before {
  height: 0 !important;
}

.custom-scroll .ant-table-body {
  overflow-y: auto !important;
  max-height: 400px; /* Adjust as needed */
}

.billboard-image-css {
  border-radius: 0.1875rem;
  background: #efefef;
  padding: 0.5rem 1rem;
}

.add-billboard-main-div {
  width: 100%;
  gap: 1.5%;
  height: 90%;
  overflow-y: scroll;
  flex-flow: nowrap;
}

/* Custom scrollbar */
.add-billboard-main-div::-webkit-scrollbar {
  width: 4px;
}

.add-billboard-main-div::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.add-billboard-main-div::-webkit-scrollbar-thumb {
  background: #5b5e5d;
  border-radius: 5px;
}

.add-billboard-main-div::-webkit-scrollbar-thumb:hover {
  background: #5b5e5d;
}

.billboard-image-thumbnail-row {
  margin-top: 0.5rem;
  gap: 1rem;
}

.loading-css {
  display: flex;
  justify-content: center;
  align-items: center;
}

.billboard-impressions-css {
  gap: 2%;
  width: 100%;
}

.billboard-checkbox-div-css {
  gap: 1rem;
  height: 3.125rem;
  display: flex;
  align-items: center;
}

.billboard-row-css {
  gap: 0.5rem;
  width: 100%;
}

.billboard-image {
  border-radius: 0.5rem;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  height: 5rem;
  width: 5rem;
}

.billboard-add-image {
  border-radius: 0.3125rem;
  background: #f0f0f0;
  width: 5rem;
  height: 5rem;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.billboard-delete-image {
  cursor: pointer;
  margin-top: 0.5rem;
  margin-right: 0.5rem;
  display: flex;
  width: 1.625rem;
  height: 1.625rem;
  padding: 0.25rem 0.3125rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 1.625rem;
  background: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.17);
}

.billboard-select-dropdown .ant-select-item-empty {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
.add-billboard-scroll {
  height: 82vh;
  overflow-y: scroll;
}

.info-message {
  margin-bottom: 1rem;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  color: #5b5e5d;
}

@media (min-width: 0px) and (max-width: 768px) {
  .multiple-slot-combo-col {
    /* flex-direction: column; */
  }
  .seller-multi-slot-quantity-field {
    width: 100%;
  }
  .seller-multiple-slot-form-item {
    width: 100% !important;
  }
  .with-delete-icon {
    width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/bill-board/AddBillBoard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,yCAAyC;AACzC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,sDAAsD;EACtD,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,wDAAwD;EACxD,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,iDAAiD;EACnD;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;EACA,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mEAAmE;EACnE,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mEAAmE;EACnE,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;EACnE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;EAC/C,0CAA0C;EAC1C,oBAAoB;EACpB,0BAA0B;EAC1B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,mEAAmE;AACrE;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;;;;EAIE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mEAAmE;EACnE,uBAAuB;AACzB;;AAEA,yBAAyB;;AAEzB;EACE,uBAAuB;AACzB;;AAEA;EACE,mEAAmE;AACrE;;AAEA,iBAAiB;AACjB;;EAEE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;EACxB,0BAA0B;EAC1B,mEAAmE;EACnE,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB,EAAE,qBAAqB;AAC1C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".add-billboard-css {\n  font-family: Roboto;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n\n.add-billboard-design {\n  font-family: Roboto;\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 600;\n}\n.width-style-100{\n  width: 100% !important;\n}\n.add-billboard-images {\n  font-family: Roboto;\n  text-align: center;\n  border-radius: 0.625rem;\n  border: 2px dashed #000;\n  width: 100%;\n  height: 33.5rem;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n/* Multi slot booking calendar stylings */\n.new-calendar-slots-row {\n  background: #f5f5f5;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column !important;\n  padding: 15px;\n  width: 100% !important;\n}\n.multiple-slot-description {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 13px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #626262;\n}\n.multiple-slot-add-button {\n  border-radius: 5px;\n  padding: 12px !important;\n  background: var(--Colors-Text-400, #3b3f3d) !important;\n  cursor: pointer;\n  height: max-content;\n  border-color: #3b3f3d !important;\n}\n.multiple-slot-combo-col {\n  width: 100% !important;\n  margin-top: 10px !important;\n  display: flex;\n  flex-direction: row;\n  gap: 0.8rem !important;\n  flex-wrap: wrap;\n}\n.range-picker-wrapper {\n  position: relative;\n}\n\n.always-clear-icon {\n  position: absolute;\n  right: 34px;\n  top: 38%;\n  transform: translateY(-50%);\n  opacity: 0;\n  cursor: pointer;\n  z-index: 10;\n  transition: opacity 0.2s ease;\n  font-size: 12px;\n  position: absolute;\n  color: #ffffff;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #bfbfbf;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.availability-ranges-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.range-picker-wrapper:hover .always-clear-icon {\n  opacity: 1;\n}\n\n/* Optional */\n.range-picker-wrapper .ant-picker-suffix {\n  transition: opacity 0.2s ease;\n}\n\n.range-picker-wrapper:hover .ant-picker-suffix {\n  opacity: 0;\n}\n.seller-multiple-slot-form-item {\n  width: 30% !important;\n}\n.multiple-slot-add-button-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #ffffff;\n  align-items: center;\n}\n.billboard-image-main-div {\n  height: 33.5rem !important;\n  width: 100% !important;\n  background-size: cover;\n  background-position: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n  border-radius: 0.625rem;\n}\n.billboard-select-feild {\n  font-family: Roboto;\n  width: 100%;\n  height: 3.125rem;\n  padding: 0.2rem 0.5rem;\n  align-items: center;\n  border-radius: 0.3125rem;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);\n  background: #fcfcfc;\n}\n.ant-input-affix-wrapper:not(.ant-input-disabled):hover {\n  z-index: 0;\n}\n.ant-input-affix-wrapper:focus {\n  z-index: 0;\n}\n.billboard-select-feild .ant-select-item-option-state {\n  display: none !important;\n}\n\n.billboard-select-dropdown\n  .ant-select-item-option-selected\n  .ant-select-item-option-state {\n  color: #fff !important;\n}\n\n.billboard-select-feild .ant-select-selection-item {\n  font-size: 1rem !important;\n  font-style: normal;\n  font-weight: 500;\n  color: var(--Colors-Text-500, #0a0f0d) !important;\n}\n\n@media (max-width: 1024px) {\n  .billboard-select-feild .ant-select-selection-item {\n    font-size: 1rem !important;\n    font-style: normal;\n    font-weight: 500 !important;\n    color: var(--Colors-Text-500, #0a0f0d) !important;\n  }\n}\n\n.billboard-select-feild .ant-select-selector {\n  background: #fcfcfc !important;\n}\n\n.billboard-select-feild .ant-select-selector:hover {\n  border-color: none;\n}\n\n.billboard-select-feild .ant-select-selection-wrap {\n  .ant-select-selection-placeholder {\n  color: #757575 !important;\n  font-size: 14px !important;\n  font-style: normal;\n  font-weight: 400;\n  font-family: 'Roboto';\n  }\n}\n\n.billboard-input-feild {\n  height: 3.125rem;\n  padding: 0.625rem 1.25rem 0rem 1.25rem !important;\n  align-items: center;\n  margin-top: 0;\n  font-size: 14px;\n  border-radius: 0.3125rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  background: #fcfcfc !important;\n  border-color: #fcfcfc;\n  font-family: \"Roboto\";\n  box-shadow: none;\n}\n.billboard-input-feildterm {\n  height: 3.125rem;\n  padding: 0.625rem 1.25rem 0rem 1.25rem !important;\n  align-items: center;\n  margin-top: 0;\n  font-size: 1rem;\n  border-radius: 0.3125rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  /* background: #fcfcfc !important; */\n  border-color: #fcfcfc;\n  font-family: \"Roboto\";\n  box-shadow: none;\n}\n.billboard-input-feildterm:hover{\n  background-color: none !important;\n}\n.payment-term-amount {\n  border-radius: 0.5rem !important;\n  border-bottom: #f0f0f0 !important;\n  background-color: #f0f0f0 !important;\n}\n\n.billboard-text-area {\n  padding: 1.1rem 1.25rem !important;\n  line-height: 2rem;\n}\n\n.billboard-text-area.ant-input-outlined {\n  border-color: #fff !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n}\n\n.billboard-text-area.ant-input-out-of-range {\n  color: var(--Colors-Text-400, #3b3f3d) !important;\n}\n\n.billboard-input-feild.ant-input-outlined:focus {\n  border-color: #fff !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  box-shadow: none !important;\n}\n\n.billboard-input-feild input::placeholder {\n  color: #999;\n  font-weight: 400;\n}\n\n.billboard-input-feild:not(:placeholder-shown) {\n  padding-bottom: 0 !important;\n}\n\n.billboard-input-feild label {\n  padding-left: 10px !important;\n}\n\n.billboard-input-feild .floating-label.focused {\n  font-size: var(--label-focused-font-size, 12px);\n  color: var(--label-focused-color, #f10c0c);\n  top: 23px !important;\n  transform: none !important;\n  z-index: 1;\n  padding-left: 10px !important;\n}\n\n.billboard-input-feild.ant-form-item-control-input-content {\n  border-radius: 0.3125rem !important;\n  background: #fcfcfc !important;\n}\n\n.billboard-input-feild input {\n  padding-left: 0;\n  font-weight: var(--input-font-weight, 500);\n}\n\n.billboard-input-feild::placeholder {\n  font-weight: var(--placeholder-font-weight, 400);\n  color: #757575 !important;\n  padding-left: -1.25rem !important;\n}\n\n.billboard-input-feild.ant-input-status-error {\n  border-style: none !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n}\n\n.billboard-form {\n  display: flex;\n}\n\n.billboard-form-row {\n  margin-top: 0.5rem;\n  width: 100%;\n  gap: 0.8rem;\n  flex-flow: nowrap;\n}\n\n.billboard-form-column {\n  width: 32%;\n}\n\n.billboard-form-child-column {\n  width: 50%;\n}\n\n.icon-input-feild input {\n  background: #fcfcfc !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n}\n\n.payment-term input {\n  border-radius: 0.5rem !important;\n  background: #f0f0f0 !important;\n}\n\n/* Shared Input Styles */\n.icon-input-feild input,\n.payment-term input {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 1rem;\n  height: 3.125rem;\n  align-items: center;\n  margin-top: 0;\n  border: none;\n}\n\n.icon-input-feild input:not(:placeholder-shown),\n.icon-input-feild input:not([value=\"\"]),\n.payment-term input:not(:placeholder-shown),\n.payment-term input:not([value=\"\"]) {\n  border-radius: 0.5rem;\n  padding-bottom: 0 !important;\n}\n\n.icon-input-feild input::placeholder,\n.payment-term input::placeholder {\n  font-weight: 400;\n  color: #757575 !important;\n  padding-left: 1.25rem;\n}\n\n.ant-input-status-error {\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  border: none !important;\n}\n\n/* Error input handling */\n\n.payment-term .ant-input-status-error {\n  border: none !important;\n}\n\n.icon-input-feild .ant-input-group-addon {\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n}\n\n/* Addon Styles */\n.icon-input-feild .ant-input-group-addon,\n.payment-term .ant-input-group-addon {\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  border: none;\n  background: #f0f0f0;\n  color: var(--Colors-Text-200, #8e9190) !important;\n}\n\n/* Overwrite for payment-term addon */\n.payment-term .ant-input-group-addon {\n  background-color: #0a0f0d !important;\n  color: #fff !important;\n}\n\n.billboard-datepicker {\n  width: 100% !important;\n  border-left: 0px !important;\n  height: 3.125rem !important;\n  padding: 0.625rem 1.25rem !important;\n  align-items: center !important;\n  margin-top: 0 !important;\n  font-size: 1rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  background: #fcfcfc !important;\n  border-right: 0px !important;\n  border-left: 0px !important;\n  border-top: 0px !important;\n}\n\n.single-calendar {\n  width: 30% !important;\n}\n\n.single-calendar .ant-picker-range-arrow {\n  inset-inline-start: 200px !important;\n}\n\n.single-calendar .ant-picker-panel-container {\n  display: flex;\n}\n\n.single-calendar .ant-picker-panel:first-child .ant-picker-header-next-btn,\n.single-calendar\n  .ant-picker-panel:first-child\n  .ant-picker-header-super-next-btn {\n  visibility: visible !important;\n}\n\n.single-calendar .ant-picker-panels > div:nth-child(2) {\n  display: none !important;\n}\n\n.single-calendar .ant-picker-panel:last-child .ant-picker-header-next-btn,\n.single-calendar\n  .ant-picker-panel:last-child\n  .ant-picker-header-super-next-btn {\n  visibility: hidden !important;\n}\n\n.billboard-datepicker.ant-picker-status-error {\n  border-style: none !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n}\n\n.revenue-performance-height {\n  font-family: Roboto;\n  height: 3.125rem;\n}\n\n.billboard-revenue-performance-tab-1 {\n  padding: 0.3rem 0.8rem 0.3rem 0.8rem;\n  color: #838383;\n  cursor: pointer;\n}\n\n.billboard-revenue-performance-tab-2 {\n  font-weight: 500;\n  padding: 0.3rem 0.8rem 0.3rem 0.8rem;\n  border-radius: 0.3rem;\n  cursor: pointer;\n  background: #fff;\n  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.17);\n}\n\n.billboard-select-feild-design {\n  margin-bottom: 0;\n}\n\n.billboard-table {\n  border: 1px solid #fcfcfc;\n  .ant-table-cell {\n    font-family: Roboto;\n    padding: 7px 7px !important;\n  }\n}\n\n.billboard-table .ant-table-thead > tr > th {\n  text-align: left !important;\n}\n\n.billboard-table .ant-table-thead > tr > th {\n  background-color: #0a0f0d !important;\n  color: white !important;\n  font-weight: bold;\n  text-align: center;\n}\n\n.billboard-table .ant-pagination {\n  display: none;\n}\n\n.billboard-table .ant-table-thead > tr > th::before,\n.billboard-table .ant-table-thead > tr > td::before {\n  height: 0 !important;\n}\n\n.custom-scroll .ant-table-body {\n  overflow-y: auto !important;\n  max-height: 400px; /* Adjust as needed */\n}\n\n.billboard-image-css {\n  border-radius: 0.1875rem;\n  background: #efefef;\n  padding: 0.5rem 1rem;\n}\n\n.add-billboard-main-div {\n  width: 100%;\n  gap: 1.5%;\n  height: 90%;\n  overflow-y: scroll;\n  flex-flow: nowrap;\n}\n\n/* Custom scrollbar */\n.add-billboard-main-div::-webkit-scrollbar {\n  width: 4px;\n}\n\n.add-billboard-main-div::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.add-billboard-main-div::-webkit-scrollbar-thumb {\n  background: #5b5e5d;\n  border-radius: 5px;\n}\n\n.add-billboard-main-div::-webkit-scrollbar-thumb:hover {\n  background: #5b5e5d;\n}\n\n.billboard-image-thumbnail-row {\n  margin-top: 0.5rem;\n  gap: 1rem;\n}\n\n.loading-css {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.billboard-impressions-css {\n  gap: 2%;\n  width: 100%;\n}\n\n.billboard-checkbox-div-css {\n  gap: 1rem;\n  height: 3.125rem;\n  display: flex;\n  align-items: center;\n}\n\n.billboard-row-css {\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.billboard-image {\n  border-radius: 0.5rem;\n  background-size: cover;\n  background-position: center;\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n  height: 5rem;\n  width: 5rem;\n}\n\n.billboard-add-image {\n  border-radius: 0.3125rem;\n  background: #f0f0f0;\n  width: 5rem;\n  height: 5rem;\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.billboard-delete-image {\n  cursor: pointer;\n  margin-top: 0.5rem;\n  margin-right: 0.5rem;\n  display: flex;\n  width: 1.625rem;\n  height: 1.625rem;\n  padding: 0.25rem 0.3125rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 1.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.17);\n}\n\n.billboard-select-dropdown .ant-select-item-empty {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n.add-billboard-scroll {\n  height: 82vh;\n  overflow-y: scroll;\n}\n\n.info-message {\n  margin-bottom: 1rem;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  color: #5b5e5d;\n}\n\n@media (min-width: 0px) and (max-width: 768px) {\n  .multiple-slot-combo-col {\n    /* flex-direction: column; */\n  }\n  .seller-multi-slot-quantity-field {\n    width: 100%;\n  }\n  .seller-multiple-slot-form-item {\n    width: 100% !important;\n  }\n  .with-delete-icon {\n    width: 80%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
